export const USER_KEY = "vuex_user";
export const TOKEN_KEY = "vuex_token";
export const LIFE_DATA = "lifeData";
//初始状态
export const STORE_STATE = "storeState";

//mutation
export const RESET_STATE = "resetState";
export const USER_STATE_PREFIX = "user/";
export const UPDATE_TOKEN = "updateToken";
export const UPDATE_USER = "updateUser";

export const VERSION_CONTROL_STATE_PREFIX = "versionControl/";
export const UPDATE_VERSION_DATA_FORM = "updateVersionDataForm";
export const UPDATE_VERSION_FIRM = "updateVersionFirm";
